import { render, staticRenderFns } from "./videoTable.vue?vue&type=template&id=746c885d&scoped=true&"
import script from "./videoTable.vue?vue&type=script&lang=js&"
export * from "./videoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c885d",
  null
  
)

export default component.exports